import { Column } from "react-table";
import { IOptionNote } from "../../../../models/Configuration"
import { useMemo } from "react";
import { Checkbox } from "@mui/material";
import { ReactTable } from "../../../../components/table/ReactTable";
import { renderLinkedText } from "../../../../helpers/utils/linkify";

type IProps = {
    list: Array<IOptionNote>;
}

const OptionNoteTableComponent = (props: IProps) => {

    const { list } = props;

    //Table columns
    const columnns: Column<IOptionNote>[] = useMemo (
        () => [
            {
                Header: "Note",
                accessor: "value",
                Cell: ({ cell }: any) => renderLinkedText(cell.value)
            },
            {
                Header: "Header",
                accessor: "header",
                width: 90,
            },
            {
                Header: "Is Global",
                accessor: "isGlobal",
                width: 70,
                Cell: ({ cell }: any) => {
                    return (
                        <Checkbox className="row-checkbox-disabled" disabled checked={cell.value} />
                    )
                }
            },
            {
                Header: "Sort Order",
                width: 70,
                accessor: "sortOrder"
            }

        ], []
    );

    return (
        <>
            <ReactTable
                name="option-note-table"
                serverOnChange={false}
                columns={columnns}
                data={list}
                isLoading={false}
                hideToolbar={true}
            />
        </>
    )
}

export default OptionNoteTableComponent;